import React from 'react';

export const RightArrow = () => (
  <svg aria-labelledby="rightArrowTitle" role="img" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false" width="20px">
    <path d="M8.89 2l5.61 6-5.61 6-1.39-1.487L10.784 9H1.5V7h9.284L7.5 3.487 8.89 2z" fill="curretColor" fillRule="nonzero" />
  </svg>
);
